module.exports = __webpack_public_path__ + "static/media/SideMenu_Tracking.7ef31e26.svg";